// Core dependencies
import Vue from 'vue';
import axios from 'axios';

// Disable vue devtools in production
if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false;
}

new Vue({
  el: '#app',
  data() {
    return {
      packageName: (data.packageName) || 'net.easy_signup',
      html: '',
    };
  },

  mounted() {
    this.fetchPrivacy();
  },
  methods: {
    fetchPrivacy() {
      axios.get(`https://api.token-pay.net/api/privacy?package_name=${this.packageName}`).then(({ data }) => {
        this.html = data;
      })
    }
  }
});
